export const useSkipLower = (content) => {
  const modifiedString = content?.toLowerCase().replace(/\s/g, "");
  return modifiedString;
};
